import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "../Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    TableActionIconView,
    customHeaderStyle,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    defaultPaginationOptions, TableActionIconGeneric, DEFAULT_ICON_MARGIN, TableActionIconEdit
} from "root/Tables/BaseTableComponents";

import {LetterBoxDecision, LetterBoxType } from "root/DataFunctions/Constants";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const LetterboxTable = (props) => {

    const globals = useContext(GlobalContext);

    const onClickItem = (letter_box_item_id, mode) =>
    {
        props.clickHandler( mode,  props.child_uid, letter_box_item_id );
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const shouldShowToApprove = doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType);
        const shouldShowForward = doesUserHaveApplication(ApplicationTypes.POSTBOX, globals.userType)  ;
        const shouldShowAction = (+(row.letterbox_decision_type_id) === LetterBoxDecision.UNAPPROVED || +(row.letterbox_decision_type_id) === LetterBoxDecision.UNAPPROVED_RETURNED_BY_EDITOR)
                                    && shouldShowToApprove;
        const shouldShowMarkForwarded = +(row.letterbox_decision_type_id) === LetterBoxDecision.APPROVED_NOT_FORWARDED ;
        const shouldShowMarkReSubmit = +(row.letterbox_decision_type_id) === LetterBoxDecision.NOT_APPROVED  && shouldShowForward && row.post_id === null;
        //const docUrl = row.document_id !== null ? '/getFile.php?enc_docid=' + row.document_id : null ;

        return (
            <Fragment>
                { /*shouldShowDocumentView && <TableActionIconGeneric href={docUrl} style={{marginRight: DEFAULT_ICON_MARGIN}} icon='icon-folder' color='var(--s360-icon-blue)' text='View Document'/> */}
                { shouldShowAction && <TableActionIconGeneric onClick={() => onClickItem(row.letterbox_item_id,'action' )} style={{marginRight: DEFAULT_ICON_MARGIN}} icon='icon-components' color='var(--s360-icon-green)' text='Approve/Return'/> }
                { shouldShowMarkForwarded && <TableActionIconGeneric onClick={() => onClickItem(row.letterbox_item_id,'mark_sent' )} style={{marginRight: DEFAULT_ICON_MARGIN}} icon='icon-check' color='var(--s360-icon-green)' text='Mark As Sent On'/> }
                { shouldShowMarkReSubmit && <TableActionIconEdit onClick={() => onClickItem(row.letterbox_item_id,'edit' )} style={{marginRight: DEFAULT_ICON_MARGIN}} icon='icon-important' color='var(--s360-icon-green)' text='Edit & Re-submit'/> }

                {/* shouldShowApproveReturn && <TableActionIconGeneric onClick={() => onClickItem(row.letterbox_item_id, 'return')} icon='icon-question-circle' color='red' text='Return to Sender'/> */}
                {/* shouldShowApproveReturn && <TableActionIconGeneric onClick={() => onClickItem(row.letterbox_item_id, 'approve')} icon='icon-check' color='green' text='Approve'/>*/ }
                {!shouldShowAction && <TableActionIconView text="View" onClick={() => onClickItem(row.letterbox_item_id, 'view')} />}
            </Fragment>
        );
    }

    const refStyle = {
        fontSize: '1.1rem',
        lineHeight: '1rem',
        color: '#038fde',
    }

    const typeFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        if ( +(row.letterbox_item_type_id) === LetterBoxType.MESSAGE )
        {
            return (
                <Fragment>
                    <i className="icon icon-chat" style={{fontSize: '1.5rem', marginRight: '7px'}}/>
                    <span>{cell}</span>
                </Fragment>
            );
        }
        else
        {
            return (
                <Fragment>
                    <i className="icon icon-email" style={{fontSize: '1.5rem', marginRight: '7px', marginBottom: '3px'}}/>
                    <span>{cell}</span><br/>
                    <div style={refStyle}>Ref: {row.reference_number}</div>
                </Fragment>
            );
        }
    }

    const statusColor = ( decision ) =>
    {
        switch ( +decision )
        {
            case LetterBoxDecision.APPROVED_AND_FORWARDED:
                return { color: 'green' };
            case LetterBoxDecision.RETURN_TO_SENDER:
            case LetterBoxDecision.UNAPPROVED_RETURNED_BY_EDITOR:
                return { color: 'red' };
            default:
                return { color: 'blue' };
        }
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const style = statusColor( row.letterbox_decision_type_id );

        return (
            <Fragment>
                <span style={style}>{cell}</span><br/>
            </Fragment>
        );
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        received_date: {borderRadius: defaultTopLeftCellStyle, width: "5vw"},
        letterbox_item_type: {width: "7vw"},
        toName: {width: "9vw"},
        fromName: {width: "9vw"},
        letterbox_decision_type: {width: "10vw"},
        edit_submit: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "received_date",
                text: "Received",
                sort: true,
                headerStyle: headerStyle,

            },
            {
                dataField: "letterbox_item_type",
                text: "Type",
                textAlign: "center",
                headerStyle: headerStyle,
                formatter: typeFormatter,
                style: {overflow:'hidden'},
            },
            {
                dataField: "toName",
                text: "To",
                textAlign: "center",
                headerStyle: headerStyle
            },
            {
                dataField: "fromName",
                text: "From",
                textAlign: "center",
                headerStyle: headerStyle
            },
            {
                dataField: "letterbox_decision_type",
                text: "Status",
                textAlign: "left",
                headerStyle: headerStyle,
                formatter: statusFormatter,
                style: {overflow:'hidden'},
            },
            {
                dataField: "edit_submit",
                text: "Options",
                textAlign: "right",
                headerStyle: headerStyle,
                align: 'right',
                formatter: linkFormatter
            }
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default LetterboxTable;

LetterboxTable.propTypes = {
    letter_box_item_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};